import { VehicleType } from 'types/common/vehicles';
import { RLRClaimResponse, RLRJourneyError } from 'types/journeys/loyaltyRewards';
import { RLRProductCodesEnumType, RLRProductType, RLRVehicleInfoEnumType } from 'constants/journeys/loyaltyRewardsEnums';

export const SET_RLR_PAGE_MODEL = 'SET_RLR_PAGE_MODEL';
export const SET_RLR_JOURNEY_ERROR = 'SET_RLR_JOURNEY_ERROR';
export const SET_RLR_JOURNEY_REWARD = 'SET_RLR_JOURNEY_REWARD';
export const SET_RLR_VEHICLES = 'SET_RLR_VEHICLES';
export const ADD_RLR_VEHICLE = 'ADD_RLR_VEHICLE';
export const SET_CHOSEN_VEHICLE = 'SET_CHOSEN_VEHICLE';
export const SET_VEHICLE_DISPLAY_MODALITY = 'SET_VEHICLE_DISPLAY_MODALITY';
export const SET_CLAIM_REWARD_RESPONSE = 'SET_CLAIM_REWARD_RESPONSE';

export const setRLRPageModel = (pageModel: object) => ({
  type: SET_RLR_PAGE_MODEL,
  payload: pageModel,
});

export const setRLRJourneyError = (error: RLRJourneyError) => ({
  type: SET_RLR_JOURNEY_ERROR,
  payload: error,
});

export const setRLRJourneyReward = (reward: RLRProductType | null) => ({
  type: SET_RLR_JOURNEY_REWARD,
  payload: reward,
});

export const setRLRVehicles = (vehicles: VehicleType[]) => ({
  type: SET_RLR_VEHICLES,
  payload: vehicles,
});

export const addRLRVehicle = (vehicle: VehicleType) => ({
  type: ADD_RLR_VEHICLE,
  payload: vehicle,
});

export const setChosenVehicle = (vehicle: VehicleType | null) => ({
  type: SET_CHOSEN_VEHICLE,
  payload: vehicle,
});

export const setVehicleDisplayModality = (display: RLRVehicleInfoEnumType) => ({
  type: SET_VEHICLE_DISPLAY_MODALITY,
  payload: display,
});

export const setClaimRewardResponse = (payload: RLRClaimResponse) => ({
  type: SET_CLAIM_REWARD_RESPONSE,
  payload,
});

export interface SetRLRPageModel {
  type: typeof SET_RLR_PAGE_MODEL;
  payload: object,
}

export interface SetRLRJourneyError {
  type: typeof SET_RLR_JOURNEY_ERROR;
  payload: RLRJourneyError,
}

export interface SetRLRJourneyReward {
  type: typeof SET_RLR_JOURNEY_REWARD;
  payload: object,
}

export interface SetRLRVehicles {
  type: typeof SET_RLR_VEHICLES;
  payload: VehicleType[],
}

export interface AddRLRVehicle {
  type: typeof ADD_RLR_VEHICLE;
  payload: VehicleType,
}

export interface SetChosenVehicle {
  type: typeof SET_CHOSEN_VEHICLE;
  payload: object,
}

export interface SetVehicleDisplayModality {
  type: typeof SET_VEHICLE_DISPLAY_MODALITY;
  payload: RLRProductCodesEnumType,
}

export interface SetClaimRewardResponse {
  type: typeof SET_CLAIM_REWARD_RESPONSE;
  payload: RLRClaimResponse,
}

export type LoyaltyRewardsAction = SetRLRPageModel
  | SetRLRJourneyError
  | SetRLRJourneyReward
  | SetRLRVehicles
  | AddRLRVehicle
  | SetChosenVehicle
  | SetVehicleDisplayModality
  | SetClaimRewardResponse;
